export enum RolesList {
  LONE = "L1",
  LTWO="L2",
  LTHREE="L3",
  LFOUR="L4"
}
